import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule, MetaReducer } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { AuthEffects } from './auth/auth.effects';
import { reducers } from '@app/store/store.reducers';
import { SnackbarEffects } from './snackbar/snackbar.effects';
import { AppState } from './store.states';
import { initStateFromLocalStorage } from './auth/auth.meta-reducers';

export const metaReducers: MetaReducer<AppState>[] = [initStateFromLocalStorage];

@NgModule({
  imports: [
    MatSnackBarModule,
    SharedModule,
    EffectsModule.forRoot([AuthEffects, SnackbarEffects]),
    StoreModule.forRoot(reducers, {
      metaReducers,
    }),
  ],
  declarations: [],
})
export class AppStoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: AppStoreModule
  ) {
    if (parentModule) {
      throw new Error(
        'AppStoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
